import { Directive, ElementRef, Input, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Platform } from '@ionic/angular';
import { CommonUtilsService } from '../services/common-utils.service';

@Directive({
  selector: '[bpAdjustSizeIfKeyboardIsOpen]',
  standalone: false
})
export class AdjustSizeIfKeyboardIsOpenDirective implements OnDestroy {
  private el = inject(ElementRef);
  private utils = inject(CommonUtilsService);
  private platform = inject(Platform);

  private subscription: Subscription;
  private initialDisplaySize: string;

  @Input('bpAdjustSizeIfKeyboardIsOpen') set height(v: boolean) {
    // Adjust size only in Mobile Phone
    if (
      this.platform.is('hybrid') &&
      !this.platform.is('tablet') &&
      !this.platform.is('ipad')
    ) {
      this.subscription = this.utils.keyboardOpened$.subscribe(open => {
        if (v === false) {
          this.el.nativeElement.style.height = open
            ? this.initialDisplaySize
            : '53px';
        } else {
          this.el.nativeElement.style.height = open
            ? '53px'
            : this.initialDisplaySize;
        }
      });
    }
  }

  constructor() {
    this.initialDisplaySize = this.el.nativeElement.style.height;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
